import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from '../ui/Button';
import { cn } from '../../utils/cn';
import { getLicenseLimitBannerVariant } from '../../utils/licenseUsage';

const LicenseLimitBanner = ({ user, className }) => {
  const navigate = useNavigate();
  const variant = getLicenseLimitBannerVariant(user);

  if (!variant) return null;

  const { kind } = variant;

  if (kind === 'no_license') {
    return (
      <div
        className={cn(
          'mb-4 flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl border border-amber-500/35 bg-amber-500/10 px-4 py-3',
          className
        )}
      >
        <div className="flex gap-3 flex-1 min-w-0">
          <Icon name="AlertCircle" size={20} className="text-amber-600 shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-foreground">Sem licença ativa</p>
            <p className="text-xs text-muted-foreground mt-0.5">
              Adquira ou renove um plano para gerar documentos e usar assinatura digital.
            </p>
          </div>
        </div>
        <Button
          type="button"
          size="sm"
          className="shrink-0"
          onClick={() => navigate('/license-store')}
        >
          Ver planos
        </Button>
      </div>
    );
  }

  const atLimit = kind === 'at_limit';
  const docs = variant.docs;
  const sigs = variant.sigs;

  return (
    <div
      className={cn(
        'mb-4 flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl border px-4 py-3',
        atLimit
          ? 'border-destructive/35 bg-destructive/5'
          : 'border-amber-500/35 bg-amber-500/10',
        className
      )}
    >
      <div className="flex gap-3 flex-1 min-w-0">
        <Icon
          name={atLimit ? 'AlertTriangle' : 'Clock'}
          size={20}
          className={cn('shrink-0 mt-0.5', atLimit ? 'text-destructive' : 'text-amber-600')}
        />
        <div className="text-sm">
          <p className="font-medium text-foreground">
            {atLimit ? 'Limite da licença atingido' : 'Licença próxima do limite'}
          </p>
          <ul className="text-xs text-muted-foreground mt-1 space-y-0.5 list-disc list-inside">
            {docs?.max != null && (docs.isAtLimit || docs.isLow) ? (
              <li>
                Documentos: {docs.used} de {docs.max}
                {docs.isAtLimit ? ' (esgotado)' : ''}
              </li>
            ) : null}
            {sigs?.max != null && (sigs.isAtLimit || sigs.isLow) ? (
              <li>
                Assinaturas: {sigs.used} de {sigs.max}
                {sigs.isAtLimit ? ' (esgotado)' : ''}
              </li>
            ) : null}
          </ul>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 shrink-0">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => navigate('/my-license')}
        >
          Minha licença
        </Button>
        <Button type="button" size="sm" onClick={() => navigate('/license-store')}>
          {atLimit ? 'Renovar plano' : 'Ver planos'}
        </Button>
      </div>
    </div>
  );
};

export default LicenseLimitBanner;
